import { Breadcrumbs, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { Link as RouterLink, useLocation, useSearchParams } from "react-router-dom";

// import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

import { StyledSeperator } from "./Seperator.styled";
import { BreadCrumbData } from "./Seperator.types";
import { getBreadcrumbsData } from "./Seperator.utils";
import { DocumentSettings } from "../../models/document-settings";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { parseDocumentSettingsIdToNumber } from "../../pages/documents/document/add-document/AddDocument.utils";
import { useTheme } from "@emotion/react";


function Seperator() {

  const theme = useTheme();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const documentSettingsId: number | null = parseDocumentSettingsIdToNumber(searchParams.get('documentType'));
  
  const documentsSettings: DocumentSettings[] | undefined = useSelector((state: RootState) => state.documents.settings);

  const breadcrumbs: React.ReactNode[] = createBreadcrumbs(
    getBreadcrumbsData(
      location.pathname, 
      documentsSettings?.find(settings => settings.id === documentSettingsId),
      location.state?.breadcrumbData
    )
  );


  function createBreadcrumbs(breadcrumbData: BreadCrumbData[]): React.ReactNode[]{

    return breadcrumbData.map((item: BreadCrumbData, index: number) =>
        index !== breadcrumbData.length - 1 && item.link ? (
          <Link
            component={RouterLink}
            to={item.link || ""}
            underline="hover"
            key={index}
            // color="inherit"
            // color={theme.colors.highlight_color}
            state={{
              // ...location.state,
              ...item.state,
              breadcrumbData: breadcrumbData.slice(0, index + 1),
            }}
            sx={{
              color: theme.colors.input_border_color,
              '&:visited': { color: theme.colors.input_border_color },
              '&:hover':   { color: theme.colors.input_border_color },
              '&:active':  { color: theme.colors.input_border_color },
            }}
          >
            {item.name}
          </Link>
        ) : (
          <Typography key={index} sx={{ color: theme.colors.input_border_color }}>
            {item.name}
          </Typography>
        )
      );
  }


  return (
    <StyledSeperator>
      <Breadcrumbs
        separator={<NavigateBeforeIcon sx={{ color: theme.colors.input_border_color }} fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </StyledSeperator>
  );
}

export default Seperator;
